'use client';

import { useTranslations } from 'next-intl';

import { SavedSearchIllustration } from './SavedSearchIllustration';

import { AppUpsellModal } from '@/components/AppUpsellModal';
import { SAVED_SEARCH_MODAL_TRACKING_ID } from '@/modules/savedSearch/constants';

type Props = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  isSheet?: boolean;
};

export function SavedSearchUpsellModal({ isOpen, setOpen, isSheet }: Props) {
  const t = useTranslations('common');

  return (
    <AppUpsellModal
      id="saved-search-upsell-modal"
      isOpen={isOpen}
      setOpen={setOpen}
      isSheet={isSheet}
      title={t('SavedSearch.Title')}
      description={t('SavedSearch.Description')}
      illustration={<SavedSearchIllustration />}
      trackingId={SAVED_SEARCH_MODAL_TRACKING_ID}
      placement="saved_search_modal"
    />
  );
}
